import { Component, Input, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { CRMReportRequest } from '../crm-data-by-zip-territory.component';
import { DataGridCreatedEvent } from '../crm-report-datagrid/crm-report-datagrid-defns';
import saveAs from 'file-saver';

@Component({
  selector: 'app-crm-report-crm-prospects-with91-ma',
  templateUrl: './crm-report-crm-prospects-with91-ma.component.html',
  styleUrls: ['./crm-report-crm-prospects-with91-ma.component.scss']
})
export class CrmReportCrmProspectsWith91MAComponent implements OnInit {

  @Input()
  reportRequest: CRMReportRequest;

  childDataGrids: Array<DataGridCreatedEvent> = new Array<DataGridCreatedEvent>();

  crmProspectsw91MA_heading1: string = '';

  workbook: any;
  excelColMaxWidth = 30;
  excelColMinWidth = 13;
  
  constructor() { }

  ngOnInit(): void {
    this.setReportHeadings();
  }

  setReportHeadings(){    
    this.setReportHeadings_CRMProspects();       
  }

  setReportHeadings_CRMProspects(){
    if(this.reportRequest.territoryValue){
      this.crmProspectsw91MA_heading1 = 'CRM Accounts in the Geography of ' + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.crmProspectsw91MA_heading1 = 'CRM Accounts within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }
  }

  async exportExcel(e) {
    this.workbook = new Workbook();

    //All Leads
    let crmProspects_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'CRM_Prospects_With91MA');

    if(crmProspects_datagrid_idx >= 0){
      await this.createCRMProspects_worksheet(this.childDataGrids[crmProspects_datagrid_idx].dataGridComponent);
    }
    
    await this.workbook.xlsx.writeBuffer()
    .then(function (buffer: BlobPart) {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'cdbAccountListMA.xlsx');
    });
  }

  //Export All Leads Details tab
  async createCRMProspects_worksheet(dataGrid: DxDataGridComponent, columnFormatDetails?: Array<any>){

    const worksheet = this.workbook.addWorksheet('cdbAccountListMA');

    await exportDataGrid({
      component: dataGrid.instance,
      worksheet: worksheet,
      topLeftCell: { row: 2, column: 1 },
    }).then((cellRange) => {

      //Set default alignment and font properties at the worksheet level
      worksheet.eachRow((row, i) => {
        row.alignment = {
          vertical: 'top',          
          wrapText: true
        }

        row.font = {
          name: 'Tahoma',
          size: 10
        }

        row.border = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        };
      });        
      
      
    
    }).then(() => {
      
      let parser = new DOMParser();

      const acctnumColumn = worksheet.getColumn(1);

      acctnumColumn.eachCell((cell, rowNum) => {
        if(rowNum > 2){
          let parsedHtml = parser.parseFromString(cell.value, 'text/html');
          let anchorElement = parsedHtml.getElementsByTagName("a")[0];
          
          cell.value = {
            text: anchorElement.textContent,
            hyperlink: anchorElement.getAttribute('href'),
            tooltip: anchorElement.getAttribute('href')
          };    
          
          cell.font = { name: 'Tahoma', size: 10, color: { argb: '0000ff' }, underline: true };
        }
      });

    }).then(() => {

      //Prepare Sheet header-1
      worksheet.mergeCells('A1:R1');      
      worksheet.getCell('A1').value = {
        'richText': [
          {'font': {'size': 18,'color': {'argb': '000000'},'name': 'Tahoma'},'text': this.crmProspectsw91MA_heading1},          
        ]
      };

      worksheet.getCell('A1').alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      }
      
      worksheet.getRow(1).height = 24; 

      //Set format for table header row
      const tableHeaderRow = worksheet.getRow(2);
      
      tableHeaderRow.fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'ADD8E6'},
      };                  

      tableHeaderRow.font = { name: 'Tahoma', size: 11, color: { argb: '000000' }, bold: true };
      tableHeaderRow.height = 65;    

      //fill style
      const header_fill_1 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'40E0D0'},
      };            

      //Change fill color for certain header cells
      [37,38].forEach((i) => {
        tableHeaderRow.getCell(i).fill = header_fill_1;
      });      

      //fill style
      const header_fill_2 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'AFEEEE'},
      };            

      //Change fill color for certain header cells (from col 38 to col 128)
      for(let i=39;i<=129;i++) {
        tableHeaderRow.getCell(i).fill = header_fill_2;
      };

      //Adjust column widths for better appearance    
      worksheet.columns.forEach((column,i) => {

        if(column.width > this.excelColMaxWidth){
          column.width = this.excelColMaxWidth;
        }

        let hdrTxtLength = tableHeaderRow.getCell(i+1).value.length;
        //adjust column width based on the header text length
        if(hdrTxtLength > 16){            
          column.width = 18.5;
        }else if(hdrTxtLength >= 10 && hdrTxtLength <= 16){
          column.width = this.excelColMinWidth;
        }
      
      });

      

    });

  }

  //Receive datagrid created events and store the event meta-data.
  //This will be used for the export-to-excel functionality
  onDataGridCreated(event: DataGridCreatedEvent){       
    this.childDataGrids.push(event);
  }

}
